'use strict';

var ajax = require('./../../../../../app_storefront_core/cartridge/js/ajax'),
    carousel = require('./../../carousel'),
	util = require('./../../util');
var currentLocation = window.location.href;
var isPostLoadEnabled = !!SitePreferences.isPLPPostLoadEnabled;
var initialPageSize = SitePreferences.initialPageSize,
	resultPageSize = (+util.getParameterValueFromUrl('sz', currentLocation) || SitePreferences.resultPageSize),
	loadPartPageSize = +SitePreferences.loadPartPageSize;
var productTile = require('./../../product-tile');
var isForceBreak = false;
// resolved when products of the initially loaded page are post-loaded
var initialLoad = $.Deferred();

/**
 * Returns size of the page rendered by server: requested "sz" is ignored by server if it exceeds max page size
 */
function getPageSize(){
	return +$('#search-result-items').data('pageSize') || resultPageSize;
}

function getRequestsURLs(){
	var pageSize = getPageSize();
	var requestsUrlArr = [];
	if (!(loadPartPageSize > 0)) {
		return requestsUrlArr;
	}
	for(var offset = initialPageSize; offset < pageSize; offset += loadPartPageSize){
		// the last request loads only the rest of the page, not products of the next page
		requestsUrlArr.push(generateStepURL(offset, Math.min(loadPartPageSize, pageSize - offset)));
	}
	return requestsUrlArr;
}

function generateStepURL(offset, stepSize){
	var start = +util.getParameterValueFromUrl('start', currentLocation) || 0;
	var clearStartURL = util.removeParamFromURL(currentLocation, 'start');
	// step is defined by "start" only: server overrides it by "page" (see Search-showProductGrid)
	clearStartURL = util.removeParamFromURL(clearStartURL, 'page');
	clearStartURL = util.removeParamFromURL(clearStartURL, 'restore');
	var startValue = start + offset;
	var resultURL = util.appendParamToURL(clearStartURL, 'start', startValue);
	resultURL = util.removeParamFromURL(resultURL, 'sz');
	resultURL = util.appendParamToURL(resultURL, 'sz', stepSize);
	// render all requested products, not only initial count of them (see search/productgrid)
	resultURL = util.appendParamToURL(resultURL, 'postload', true);
	resultURL = util.ajaxUrl(resultURL);
	return resultURL;
}

function updatePLPWithProducts(){
	$(document).ready(function(){
		var requestURLs = getRequestsURLs();
		loadMoreProducts(requestURLs);
	});
}

function loadMoreProducts(requestURLs, step){
	var step = step || 0;
	var url = requestURLs[step];
	if(!url || isForceBreak){
		$(document).trigger('search.update', [{istriggered: true}]);
		productTile.init();
		initialLoad.resolve();
		return false;
	}
	$.ajax({
		url: url,
		method: 'GET'
	}).done(function (data) {
		if(data){
			var resultProductsWrapper = $(data).find('#search-result-items');
			if(!!resultProductsWrapper.length && !!resultProductsWrapper.find('.js-product_tile').length){
				productTile.init({container: resultProductsWrapper});
				$('#search-result-items').append(resultProductsWrapper.children());
				step += 1;
                carousel.init({});
				loadMoreProducts(requestURLs, step);
				return;
			}
		}
		initialLoad.resolve();
	}).fail(function () {
		initialLoad.resolve();
	});
}


function initEvents(){
	$(document).on('search.update', function(e, isTriggered){
		if( !isTriggered || ( typeof isTriggered == 'object' && !('istriggered' in isTriggered) && ('url' in isTriggered) ) ){
			currentLocation = isTriggered.url;
			isForceBreak = false;
			updatePLPWithProducts();
		}
	});
	$(document).on('click', '.b-pagination a', function(e){
		currentLocation = $(this).attr('href');
		isForceBreak = true;
	});
	
	$(document).on('click', '.js-pagesizeholder a', function(e){
		var pageSizeUrl = $(this).attr('href');
		resultPageSize = +util.getParameterValueFromUrl('sz', pageSizeUrl);
	});
}

module.exports = {
	init : function () {
		if(isPostLoadEnabled){
			updatePLPWithProducts();
			initEvents();
		}
	},
	/**
	 * @returns {Promise} resolved when all products of the page are loaded
	 */
	whenLoaded : function () {
		return isPostLoadEnabled ? initialLoad.promise() : $.Deferred().resolve().promise();
	}
}
